import { AssignmentResponse } from '@/types';
import { useState } from 'react';
import { toast } from 'sonner';
import { CheckCircle, Copy, Link } from 'lucide-react';
import { Button, buttonVariants } from '../../ui/button';
import { Checkbox } from '../../ui/checkbox';
import { cn } from '@/components/ui/utils';

interface InterviewLinkProps {
  assignment: AssignmentResponse;
}

export const InterviewLink = ({ assignment }: InterviewLinkProps) => {
  const [needsRecording, setNeedsRecording] = useState(true);

  const handleCopyInterviewLink = async (needsRecording: boolean) => {
    const interviewUrl = `${window.location.origin}/conversation/${assignment.id}${needsRecording ? '?record=true' : ''}`;

    try {
      await navigator.clipboard.writeText(interviewUrl);
      toast.success('Interview link copied to clipboard');
    } catch (error) {
      toast.error('Failed to copy link');
    }
  };

  if (!assignment.personaId) return null;

  return (
    <div
      className={buttonVariants({
        variant: assignment.personaId ? 'secondary' : 'outline',
        className: cn(
          'justify-start h-auto !px-3',
          assignment.personaId ? 'py-1' : 'py-3'
        ),
      })}
    >
      <div className='flex items-center justify-between w-full'>
        <div className='flex items-center gap-2'>
          <Link className='h-4 w-4' />
          <span>Interview Link</span>
          <CheckCircle className='h-3 w-3 text-green-600' />
        </div>

        <div className='flex items-center gap-3'>
          <label className='flex items-center gap-2 text-xs text-muted-foreground select-none'>
            <Checkbox
              checked={needsRecording}
              onCheckedChange={checked => setNeedsRecording(checked === true)}
              className='border-gray-400'
            />
            <span>Record</span>
          </label>
          <Button
            variant='default'
            size='sm'
            onClick={() => handleCopyInterviewLink(needsRecording)}
            className='text-xs active:translate-y-0.5'
          >
            <Copy />
            Copy
          </Button>
        </div>
      </div>
    </div>
  );
};
